import { defineMessage } from 'services/localization';

export const messages = {
    edit: defineMessage('edit'),
    archive: defineMessage('archive'),
    activate: defineMessage('activate'),
    delete: defineMessage('delete'),
    viewHistory: defineMessage('view_history'),
    areYouSure: defineMessage('are_you_sure'),
    deleteSuccess: defineMessage('groupname_has_been_deleted'),
    archiveSuccess: defineMessage('groupname_has_been_archived'),
    activateSuccess: defineMessage('groupname_is_now_active'),
};
